import React, { useState, useEffect, useRef } from 'react'
import styles from './EmotionSelectModal.module.css'

export const emotions = [
  { id: 'happy', label: '행복', color: '#FF6B9D' },
  { id: 'excited', label: '기대', color: '#8B6914' },
  { id: 'love', label: '사랑', color: '#B8405E' },
  { id: 'calm', label: '평온', color: '#5F7161' },
  { id: 'anxious', label: '걱정', color: '#8B8B4F' },
  { id: 'proud', label: '뿌듯', color: '#5B8BA8' },
  { id: 'tired', label: '피곤', color: '#4A5568' },
  { id: 'sad', label: '슬픔', color: '#4682B4' },
  { id: 'lonely', label: '외로움', color: '#9CA3AF' },
  { id: 'angry', label: '화남', color: '#654321' },
  { id: 'confused', label: '혼란', color: '#607D8B' },
  { id: 'depressed', label: '우울', color: '#8B5A8B' }
]

const EmotionSelectModal = ({ isOpen, onClose, onSelectEmotion, date }) => {
  const [selectedEmotion, setSelectedEmotion] = useState(null)
  const modalContentRef = useRef(null)

  const handleEmotionClick = (emotion) => {
    setSelectedEmotion(emotion)
  }

  const handleSubmit = () => {
    if (selectedEmotion) {
      onSelectEmotion(selectedEmotion)
      setSelectedEmotion(null)
    }
  }

  const handleClose = () => {
    setSelectedEmotion(null)
    onClose()
  }

  useEffect(() => {
    if (isOpen && modalContentRef.current) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const viewportHeight = window.innerHeight
      const modalHeight = modalContentRef.current.offsetHeight
      
      const topPosition = scrollTop + (viewportHeight / 2) - (modalHeight / 2)
      modalContentRef.current.style.top = `${Math.max(20, topPosition)}px`
    }
  }, [isOpen])

  if (!isOpen) return null

  return (
    <div className={styles.modalOverlay}>
      <div 
        ref={modalContentRef}
        className={styles.modalContent} 
        onClick={(e) => e.stopPropagation()}
      >
        <button className={styles.closeButton} onClick={handleClose}>
          <i className="fas fa-times"></i>
        </button>

        <div className={styles.dateDisplay}>{date}</div>
        
        <div className={styles.title}>
          오늘 하루 느꼈던
          <br />
          감정을 선택해세요
        </div>
        
        <div className={styles.subtitle}>
          가장 많이 느낀 감정을 찾아 보세요
        </div>

        <div className={styles.emotionGrid}>
          {emotions.map((emotion) => (
            <button
              key={emotion.id}
              className={`${styles.emotionButton} ${
                selectedEmotion?.id === emotion.id ? styles.selected : ''
              }`}
              style={{ 
                backgroundColor: emotion.color,
                opacity: selectedEmotion?.id === emotion.id ? 1 : 0.8
              }}
              onClick={() => handleEmotionClick(emotion)}
            >
              <div className={styles.emotionLabel}>{emotion.label}</div>
            </button>
          ))}
        </div>

        <button 
          className={styles.submitButton}
          onClick={handleSubmit}
          disabled={!selectedEmotion}
        >
          다음
        </button>
      </div>
    </div>
  )
}

export default EmotionSelectModal
